var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(-61.832 -459.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 24,
    height: 24,
    transform: "translate(61.832 459.744)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252",
    transform: "translate(63.832 407.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(0 61.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248-2",
    "data-name": "Group 1248",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M10.579,152.938a1.137,1.137,0,0,1-1.181,0L0,147.2v7.627a2.953,2.953,0,0,0,2.952,2.952h14.1A2.953,2.953,0,0,0,20,154.827V147.2Z",
    transform: "translate(0 -147.2)",
    fill: "#15345a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251",
    transform: "translate(0.094 57.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M19,57.088H4.905A2.934,2.934,0,0,0,2.048,59.4l9.917,6.045L21.859,59.4A2.934,2.934,0,0,0,19,57.088Z",
    transform: "translate(-2.048 -57.088)",
    fill: "#15345a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFillIcon);
export default __webpack_public_path__ + "static/media/emailFillIcon.a32acbc788fbc5739ef4d104772a5845.svg";
export { ForwardRef as ReactComponent };